export const shouldHideDesktopNavigation = (
  slug: string,
  is404: boolean,
  pathName: string,
): boolean =>
  slug === "nya-startsidan" ||
  slug === "start" ||
  slug === "500" ||
  is404 ||
  pathName.startsWith("/om-webbplatsen");
